module.exports = __webpack_public_path__ + "static/assets/8bcd9c00e30a0af9d832735651fd9643.svg";